/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "list_item_teaser_group_variant_default": "",
  "list_item_teaser_group_size_default": "sm:gap-1.5",
  "list_item_teaser_group_colors_default": "",
  "list_item_teaser_image_variant_default": "",
  "list_item_teaser_image_size_default": "!mx-0",
  "list_item_teaser_image_colors_default": "",
  "list_item_teaser_caption_variant_default": "",
  "list_item_teaser_caption_size_default": "",
  "list_item_teaser_caption_colors_default": "",
  "list_item_teaser_headline_variant_default": "",
  "list_item_teaser_headline_size_default": "!text-al-headline-xs sm:!text-al-headline-sm",
  "list_item_teaser_headline_colors_default": "",
  "list_item_teaser_description_variant_default": "",
  "list_item_teaser_description_size_default": "sm:mt-0.5 sm:text-al-body-lg",
  "list_item_teaser_description_colors_default": "",
  "list_item_teaser_variant_default": "grid grid-cols-2 sm:grid-cols-1",
  "list_item_teaser_size_default": "gap-2",
  "list_item_teaser_colors_default": "",
  "list_item_variant_default": "",
  "list_item_size_default": "",
  "list_item_colors_default": "",
  "list_variant_default": "grid sm:grid-cols-2 md:grid-cols-4",
  "list_colors_default": "",
  "list_size_default": "gap-3 md:gap-6",
  "headline_variant_default": "block",
  "headline_colors_default": "",
  "headline_size_default": "mb-3.5 text-al-headline-xs sm:text-al-headline-sm",
  "variant_default": "relative wings",
  "colors_default": "bg-white wings-white",
  "size_default": "py-4 md:py-10 px-6"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "RecommendedArticles");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;